import { createOutlineIcon } from "../createIcon";

export const CalendarOutlineIcon = createOutlineIcon(
  <>
    <path d="M5 8.914h14M6.81 3v1.543M17 3v1.543m3 2.7V18.3c0 1.491-1.194 2.7-2.667 2.7H6.667C5.194 21 4 19.791 4 18.3V7.243c0-1.491 1.194-2.7 2.667-2.7h10.666c1.473 0 2.667 1.209 2.667 2.7Z" />
  </>,
  "CalendarOutlineIcon"
);
